// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpaceForm__form-d2101e {
  flex: 1;
  overflow: auto;
  padding: 24px;
}

.SpaceForm__text-field-fc4b08 {
  margin-bottom: 16px;
}

.SpaceForm__hide-e97f3c {
  display: none;
}

.SpaceForm__radio-gap-d70b57 {
  margin-top: 0;
  margin-bottom: 24px;
  padding: 0;
}

.SpaceForm__section-indent-e8949f {
  margin-bottom: 32px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/components/SpaceForm/SpaceForm.styles.m.css"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,cAAA;EACA,aAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,UAAA;AACF;;AAEA;EACE,mBAAA;AACF","sourcesContent":[".form {\n  flex: 1;\n  overflow: auto;\n  padding: 24px;\n}\n\n.text-field {\n  margin-bottom: 16px;\n}\n\n.hide {\n  display: none;\n}\n\n.radio-gap {\n  margin-top: 0;\n  margin-bottom: 24px;\n  padding: 0;\n}\n\n.section-indent {\n  margin-bottom: 32px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `SpaceForm__form-d2101e`,
	"text-field": `SpaceForm__text-field-fc4b08`,
	"textField": `SpaceForm__text-field-fc4b08`,
	"hide": `SpaceForm__hide-e97f3c`,
	"radio-gap": `SpaceForm__radio-gap-d70b57`,
	"radioGap": `SpaceForm__radio-gap-d70b57`,
	"section-indent": `SpaceForm__section-indent-e8949f`,
	"sectionIndent": `SpaceForm__section-indent-e8949f`
};
module.exports = ___CSS_LOADER_EXPORT___;
